import {
  NetInfoAdapterInterface,
  NetInfoChangeHandler,
  NetInfoState,
  NetInfoSubscription,
} from "@citychallenge/core";

export class NetInfoAdapter implements NetInfoAdapterInterface {
  public async fetch(_requestedInterface?: string): Promise<NetInfoState> {
    // TODO: Implement
    return {
      isConnected: true,
      isInternetReachable: true,
    };
  }

  public addEventListener(
    _listener: NetInfoChangeHandler
  ): NetInfoSubscription {
    // TODO: Implement
    return () => null;
  }
}
